import { getLastSelectedCdekAddress } from './cdek.js';
import { calculateOrderPrice } from './deliveryOrder.js';
function setMhandShopAddress(shop) {
    const deliveryAddressBlock = document.querySelector('.delivery__address');
    if (deliveryAddressBlock && shop) {
        deliveryAddressBlock.innerHTML = `Адрес доставки: Самовывоз<br>Магазин MHAND: ${shop.addr}`;
        // console.log(`✅ Установлен адрес магазина MHAND: ${shop.addr}`);
    }
}

function toggleMapsVisibility(selectedRadioId) {
    const cdekMap = document.querySelector('.order-section__card__delivery-map[data-display="cdek"]');
    const mhandMap = document.querySelector('.order-section__card__delivery-map[data-display="mhand"]');
    const deliveryAddressBlock = document.querySelector('.delivery__address');

    if (cdekMap) cdekMap.style.display = 'none';
    if (mhandMap) mhandMap.style.display = 'none';
    
    if (selectedRadioId === 'delivery-way-2') {
        if (cdekMap) {
            cdekMap.style.display = 'flex';
            // console.log('✅ Карта CDEK показана');
        }
        // Попробуем восстановить последний выбранный адрес CDEK
        try {
            const last = getLastSelectedCdekAddress ? getLastSelectedCdekAddress() : (window.getLastSelectedCdekAddress && window.getLastSelectedCdekAddress());
            if (last && window.selectCdekAddress) {
                // Небольшая задержка, чтобы элементы гарантированно были в DOM
                setTimeout(() => window.selectCdekAddress(last), 50);
            } else {
                // Если предыдущего выбора нет — считаем цену по текущему городу (если задан)
                const orderForm = document.querySelector('#order-form');
                const cityInput = document.querySelector('#find-city-modal') || document.querySelector('#new-city-modal-input');
                const cityName = (orderForm && orderForm.dataset.city_name) || (cityInput && cityInput.value);
                if (cityName) {
                    try { calculateOrderPrice(cityName, '136'); } catch (e) {}
                }
            }
        } catch (e) {}
    } else if (selectedRadioId === 'delivery-way-3') {
        // Третий элемент - устанавливаем адрес самовывоза
        if (deliveryAddressBlock) {
            // samo-delivery
            const textValue = document.querySelector('#samo-delivery')
            if (!textValue) return
            // deliveryAddressBlock.innerHTML = `Адрес доставки: Самовывоз<br>Магазин MHAND: Выберите магазин на карте`;
            
            console.log(textValue.textContent);
            
            deliveryAddressBlock.innerHTML = `Адрес доставки: Самовывоз<br>${textValue.textContent}`;
            // console.log('✅ Установлен адрес самовывоза');
        }
    } else {
        // Все остальные случаи - скрываем все карты и очищаем адрес
        if (deliveryAddressBlock) {
            deliveryAddressBlock.innerHTML = '';
        }
        // console.log('✅ Все карты скрыты, адрес очищен');
    }
}

// Функция для инициализации обработчиков событий
function initMapVisibilityHandlers() {
    const radios = document.querySelectorAll('input[name="delivery_way__selector"]');
    const deliveryItems = document.querySelectorAll('.item-delivery');
    
    // Обработчики для radio кнопок
    radios.forEach(el => {
        el.addEventListener('change', function() {
            toggleMapsVisibility(this.id);
        });
    });
    
    // Обработчики для item-delivery элементов
    deliveryItems.forEach(item => {
        item.addEventListener('click', function() {
            // Если кликнули по первому item-delivery (личные адреса) и он пуст — открываем попап добавления адреса
            try {
                const firstItem = document.querySelectorAll('.item-delivery')[0];
                if (this === firstItem) {
                    const savedAddresses = (window.__orderState && Array.isArray(window.__orderState.personalAddresses)) ? window.__orderState.personalAddresses : [];
                    if (!Array.isArray(savedAddresses) || savedAddresses.length === 0) {
                        const modalElement = document.querySelector('[data-type="add-new-address"]');
                        if (modalElement) {
                            modalElement.dataset.modalState = 'open';
                            document.documentElement.style.overflow = 'hidden';
                        }
                    }
                }
            } catch (e) {}

            deliveryItems.forEach(i => i.classList.remove('active'));
            this.classList.add('active');
            const radio = this.querySelector('input[type="radio"]');
            if (radio) {
                if (!radio.checked) {
                    radio.checked = true;
                }
                // Диспатчим одно событие change вместо прямого вызова toggleMapsVisibility,
                // чтобы исключить двойное срабатывание и дублирующий запрос
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });
    
    // Инициализация состояния при загрузке
    const checked = document.querySelector('input[name="delivery_way__selector"]:checked');
    if (checked) {
        toggleMapsVisibility(checked.id);
        // Если при загрузке уже выбран CDEK — восстановим выбор
        if (checked.id === 'delivery-way-2') {
            try {
                const last = getLastSelectedCdekAddress ? getLastSelectedCdekAddress() : (window.getLastSelectedCdekAddress && window.getLastSelectedCdekAddress());
                if (last && window.selectCdekAddress) {
                    setTimeout(() => window.selectCdekAddress(last), 80);
                }
            } catch (e) {}
        }
    } else {
        // Если ничего не выбрано, скрываем все карты
        toggleMapsVisibility(null);
    }
    
    console.log('✅ Обработчики видимости карты CDEK инициализированы');
}

// Экспортируем функции
export {
    toggleMapsVisibility,
    initMapVisibilityHandlers,
    setMhandShopAddress
};

// Экспортируем в глобальную область для использования в других модулях
window.toggleMapsVisibility = toggleMapsVisibility;
window.initMapVisibilityHandlers = initMapVisibilityHandlers;
window.setMhandShopAddress = setMhandShopAddress; 